import React, { useState } from 'react';
import PropTypes from 'prop-types';

import UserLoginButton from 'dpl/Pages/UserAuth/components/UserLoginButton';
import UserAuthModalLoginForm from 'dpl/components/UserAuthModal/UserAuthModalLoginForm';
import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import UserAuthModalForgotPasswordForm from 'dpl/components/UserAuthModal/UserAuthModalForgotPasswordForm';
import { SIGNUP_FORM_TYPES } from 'dpl/shared/constants/shared';

export default function StripeChargeLoginButton({ onSuccessfulLogin }) {
  const [signupFormType, setSignupFormType] = useState(null);

  function showLoginForm() {
    setSignupFormType(SIGNUP_FORM_TYPES.LOGIN);
  }

  function showForgotPasswordForm() {
    setSignupFormType(SIGNUP_FORM_TYPES.FORGOT_PASSWORD);
  }

  function hideLoginForm() {
    setSignupFormType(null);
  }

  return (
    <>
      <UserLoginButton
        showSignupText={false}
        className="button button--secondary bg-transparent f2"
        onClick={showLoginForm}
      />
      {signupFormType && (
        <MiniOverlayModal
          className="UserAuthModal"
          onCloseClick={hideLoginForm}
        >
          {signupFormType === SIGNUP_FORM_TYPES.LOGIN ? (
            <UserAuthModalLoginForm
              loginOnly
              onPasswordResetClick={showForgotPasswordForm}
              onAuth={onSuccessfulLogin}
            />
          ) : (
            <UserAuthModalForgotPasswordForm onLoginClick={showLoginForm} />
          )}
        </MiniOverlayModal>
      )}
    </>
  );
}

StripeChargeLoginButton.propTypes = {
  onSuccessfulLogin: PropTypes.func.isRequired
};
